export default "__VITE_PUBLIC_ASSET__978a4637__"